module.exports = __webpack_public_path__ + "img/home3.44ed657f.jpg";